import React from 'react';
import Select from 'react-select';
import moment from 'moment';

export const Filter = ({ siteVisitOptions, stateList,cityList, stageList, vendorList, ebissuesList, subsidiesList, applyFilter, handleMultiSelectChange, handleDateInputChange, handleInputChange, stage1List = [], stage2List = [], netMeteringOptions = [], selectedValues = {} }) => {
	return (
		<div>
			<div className="filter_deals__subpart">
				<div className="filter_selector">
					<div className="row" style={{width:'100%'}}>
						<div className="col-md col-6 filter_box ">
							{selectCustom(stateList,"stateChange","Choose State",handleMultiSelectChange, selectedValues["stateChoosen"] || [])}
						</div>
						<div className="col-md col-6 filter_box ">
							{selectCustom(cityList,"cityChange","Choose City",handleMultiSelectChange, selectedValues.cityChoosen || [])}
						</div>
						<div className="col-md col-6 filter_box ">
							{selectCustom(stageList,"stageChange","Choose Stage",handleMultiSelectChange, selectedValues.stageChoosen || [])}
						</div>
						<div className="col-md col-6 filter_box ">
							{selectCustom(ebissuesList,"ebIssueChange","Choose EbIssue",handleMultiSelectChange, selectedValues.ebissueChoosen || [])}
						</div>
						<div className="col-md col-6 filter_box ">
							{selectCustom(subsidiesList,"subsidyChange","Choose Subsidy",handleMultiSelectChange, selectedValues.subsidyChoosen || [])}
						</div>
						<div className="col-md col-6 filter_box ">
							{selectCustom(vendorList,"v1Change","Choose V1",handleMultiSelectChange, selectedValues.vendorChoosen || [])}
						</div>
						<div className="col-md col-6 filter_box ">
							{selectCustom(stage1List,"stage1Change","Choose stage 1",handleMultiSelectChange, selectedValues.stage1Choosen || [])}
						</div>
						<div className="col-md col-6 filter_box ">
							{selectCustom(stage2List,"stage2Change","Choose stage 2",handleMultiSelectChange, selectedValues.stage2Choosen || [])}
						</div>
					</div>
				</div>
				<div className="row" style = {{marginBottom:10}}>
					<div className="col-lg-2 col-6" style={{padding:'0px 15px'}}>
						Sales Start Date:
						<input
						  style={{width:"100%",borderRadius:5,padding:'8px 8px'}}
						  onChange={handleDateInputChange}
						  name="startDate"
						  type='date'
						  value={selectedValues.startDate ? moment(selectedValues.startDate).format("YYYY-MM-DD") : ""}
						/>
					</div>
					<div className="col-lg-2 col-6" style={{padding:'0px 10px'}}>
						Sales End Date:
						<input
						  style={{width:"100%",borderRadius:5,padding:'8px 8px'}}
						  onChange={handleDateInputChange}
						  name="endDate"
						  type='date'
						  value={selectedValues.endDate && selectedValues.endDate != 9999999999999 ? moment(selectedValues.endDate).format("YYYY-MM-DD") : ""}
						/>
					</div>
					<div className="col-lg-1 col-6" style={{padding:'0px 10px'}}>
						% Start Value:
						<input
						  style={{width:85,borderRadius:5,padding:'8px 8px'}}
						  name="startPercentage"
						  type='number'
						  onChange={handleInputChange}
						  placeholder='Start Value'
						  value={selectedValues.startPercentage && selectedValues.startPercentage != -100 ? selectedValues.startPercentage : ""}
						/>
					</div>
					<div className="col-lg-1 col-6" style={{padding:'0px 10px'}}>
						% End Value:
						<input
						  style={{width:85,borderRadius:5,padding:'8px 8px'}}
						  name="endPercentage"
						  type='number'
						  onChange={handleInputChange}
						  placeholder='Last Value'
						  value={selectedValues.endPercentage}
						/>
					</div>
					<div className="col-lg-1 col-6" style={{padding:'0px 15px'}}>
						RMS Installed
						<div className="drop_down1">
							< select className="form-control"
							    onChange = {handleInputChange}
							    name="rmsInstalled"
								value={selectedValues.rmsInstalled}
							>
							<option selected value="">No Filter</option>
							<option value="Yes">Yes</option>
							<option value="No">No</option>
							</select>
						</div>
					</div>
					<div className="col-lg-1 col-6" style={{padding:'0px 15px'}}>
						RMS Status
						<div className="drop_down1">
							< select className="form-control"
							    onChange = {handleInputChange}
							    name="rmsStatus"
								value={selectedValues.rmsStatus}
							>
							<option selected value="">No Filter</option>
							<option value="Active">Active</option>
							<option value="Inactive">Inactive</option>
							</select>
						</div>

					</div>
					<div className="col-lg-1 col-6" style={{padding:'0px 15px'}}>
						Superfan
						<div className="drop_down1">
							< select className="form-control"
							    onChange = {handleInputChange}
							    name="zunPrime"
								value={selectedValues.zunPrime}
							>
							<option selected value="">No Filter</option>
							<option value="Yes">Yes</option>
							<option value="No">No</option>
							</select>
						</div>

					</div>

					<div className="col-lg-1 col-6 filter_box ">
						Site Visit
							{selectCustom(siteVisitOptions,"siteVisitChange","Site Visit",handleMultiSelectChange, selectedValues.siteVisitChoosen || [])}
					</div>
					<div className="col-lg-1 col-6 filter_box ">
						Net metering
							{selectCustom(netMeteringOptions,"netMeterChange","Net metering",handleMultiSelectChange, selectedValues.netMeterChoosen || [])}
					</div>
					<div className="col-md-1 col-6 filter_box filter_box_button">
							<div className="filter_selector__drop_down_label1" style={{marginBottom:'25%'}}></div>
							<button className="btn btn-success applyButton" onClick={applyFilter}>Apply Filter</button>
						</div>
				</div>
			</div>
		</div>
	);
}

const selectCustom = (options, name, placeholder, handleMultiSelectChange, selectedVal) => {
	const changeHandle = (value) => { handleMultiSelectChange(value,name) }
	return (
		<div className="drop_down1">
			<Select
				isMulti
				isSearchable
			    onChange = {(e) => {changeHandle(e)}}
			    placeholder={placeholder}
			    name={name}
				options={options}
				value={selectedVal}
			/>
		</div>
	)
}
